<template>
  <div class="bg-white">
    <div class="h48 pl24 c-cC26 yxtbiz-signup-manage-info__title">
      {{ language().lbl_baseInfo }}
    </div>
    <div class="ph24 pv24 yxtbiz-signup-manage-info__content">
      <div class="flex-1">
        <div class="content-row">
          <div class="content-col w100p">
            <span class="c-cC8C">{{ language().lbl_signupName }}：</span>
            <span class="c-cC26">{{ projectInfo.projectName }}</span>
          </div>
          <div class="content-col">
            <span class="c-cC8C">{{ language().lbl_historySignup }}：</span>
            <span class="c-cC26">{{ statisticsInfo.signedCount||0 }}/{{ statisticsInfo.historicalSignedCount||0 }}</span>
          </div>
        </div>

        <div class="content-row">
          <div class="content-col w100p">
            <span class="c-cC8C">{{ language().lbl_registration_status }}：</span>
            <yxt-tag v-if="staus[projectInfo.projectStatus]" :type="staus[projectInfo.projectStatus].type" size="mini">{{staus[projectInfo.projectStatus].text}}</yxt-tag>
          </div>
          <div class="content-col">
            <span class="c-cC8C">{{ language().lbl_to_be_reviewed }}：</span>
            <span class="c-cC26">{{ statisticsInfo.waitAuditCount ||0}} </span>
          </div>
        </div>

        <div class="content-row">
          <div class="content-col w100p">
            <span class="c-cC8C">{{ language().lbl_signupTimes }}：</span>
            <span v-if="projectInfo.startTime&&projectInfo.endTime" class="c-cC26" >
              {{ projectInfo.startTime }}~{{ projectInfo.endTime}}
              </span>
              <span v-else class="c-cC26" >
                {{ language().msg_long_term }}
              </span>
          </div>
          <div class="content-col">
            <span class="c-cC8C">{{ language().lbl_official_quota }}：</span>
            <span class="c-cC26">{{ statisticsInfo.formalCount ||0}} </span>
          </div>
        </div>
        <div class="content-row">
          <div class="content-col w100p">
            <span class="c-cC8C">{{ language().lbl_signupUrl }}：</span>
            <span class="c-cC26">{{ projectInfo.shortUrl }}</span>
            <yxt-button type="text" class="ml8" @click="copyUrl">
              <yxt-svg
                width="16px"
                height="16px"
                :remote-url="`${$staticBaseUrl}assets/8c7d1ef0/a224517d`"
                icon-class="file"
                style="transform: translateY(3px);"
              />
            </yxt-button>
          </div>
          <div v-if="projectInfo.formalQuota!==0" class="content-col">
            <span class="c-cC8C">{{ language().lbl_substitute_quota }}：</span>
            <span class="c-cC26">{{ statisticsInfo.replacementCount ||0}} </span>
          </div>
        </div>
      </div>

      <div class="pr hand">
        <div v-if="projectInfo.shortUrl" @click="qrCodeVisible = true">
          <yxtbiz-qrcode
            :size="96"
            :url="projectInfo.shortUrl"
            :hide-link="true"
            :hide-download="true"
            :padding="0"
          ></yxtbiz-qrcode>
          <div class="text-center mt8 font-size-12 lh20 c-cC26">
            {{ language().lbl_projectqrcode }}
          </div>
        </div>
      </div>
    </div>
    <!-- 项目二维码 -->
    <yxt-dialog
      :append-to-body="true"
      :visible.sync="qrCodeVisible"
      :cutline="false"
      width="410px"
    >
      <div class="text-center">
        <div class="mt8 mb16">
          <yxtbiz-qrcode
            :url="projectInfo.shortUrl"
            :size="200"
            :hide-link="false"
            :hide-download="false"
            :name="projectInfo.projectName"
            is-project
            :project-tip="language().lbl_projectqrcode"
          ></yxtbiz-qrcode>
        </div>
      </div>
    </yxt-dialog>
  </div>
</template>

<script>
import { Tooltip } from 'yxt-pc';
export default {
  name: 'YxtbizSignupManageInfo',
  inject: ['language'],
  props: {
    projectInfo: {
      type: Object
    },
    statisticsInfo: {
      type: Object
    },
    staus: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    YxtTooltip: Tooltip
  },
  data() {
    return {
      qrCodeVisible: false,
      name: 'minus',
      query: { a: 111, b: 222 },
      url: `${this.$staticBaseUrl}assets/8c7d1ef0/a224517d/file.svg`
    };
  },
  computed: {
    mediaUrl() {
      return `${this.$staticBaseUrl}assets/8c7d1ef0/a224517d/file.svg`;
    }
  },
  methods: {
    copyUrl() {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.projectInfo.shortUrl).then(() => {
          this.$message.success(this.language().msg_copy_success);
        }).catch(() => {
          // 创建text area
          const textArea = document.createElement('textarea');
          textArea.value = this.projectInfo.shortUrl;
          textArea.style.position = 'absolute';
          textArea.style.opacity = 0;
          textArea.style.left = '-999999px';
          textArea.style.top = '-999999px';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand('copy');
          textArea.remove();
          this.$message.success(this.language().msg_copy_success);
        });
      } else {
        // 创建text area
        const textArea = document.createElement('textarea');
        textArea.value = this.projectInfo.shortUrl;
        textArea.style.position = 'absolute';
        textArea.style.opacity = 0;
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
        this.$message.success(this.language().msg_copy_success);
      }
    }
  }
};
</script>
